<a type="button" class="btn btn-default" (click)="onScanRandomBarcodeidClick()">{{ 'Scan Random Barcode' | translate }}</a>
<input list="barcodes" name="barcode" [(ngModel)]="barcode">
<datalist id="barcodes">
  <option *ngFor="let barcodeItem of barcodes" value="{{ barcodeItem }}">
</datalist>
<a type="button" class="btn btn-default" (click)="onScanBarcodeClick()">{{ 'Scan Barcode' | translate }}</a>
